import React from 'react';
import styled, { css } from 'styled-components';
import LiteYouTubeEmbed from 'react-lite-youtube-embed';

import { useAmpLandingData } from '@/modules/AmpLanding/AmpLanding.hooks';
import { media } from '@/utils/mixin';
import { getYouTubeId } from '@/utils/common';

function Video() {
  const { videoTitle, videoSubtitle, videoLink } = useAmpLandingData();

  return (
    <Component>
      <Title>{videoTitle}</Title>
      <Subtitle>{videoSubtitle}</Subtitle>
      <VideoWrapper>
        <LiteYouTubeEmbed
          id={getYouTubeId(videoLink ?? '')}
          title="YouTube Embed"
        />
      </VideoWrapper>
    </Component>
  );
}

export default Video;

const Component = styled.div`
  max-width: 1280px;
  margin: 100px auto 0;
  padding: 0 20px;
`;

const Title = styled.h2`
  font-size: 36px;
  text-align: center;
  color: ${(props) => props.theme.black};

  @media (max-width: 1100px) {
    margin: 360px 0 0;
  }

  ${media.mobile(css`
    font-size: 30px;
  `)};

  @media (max-width: 450px) {
    margin: 250px 0 0;
  }
`;

const Subtitle = styled.span`
  display: block;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  margin: 16px 0 0;
  color: ${(props) => props.theme.blue100};
`;

const VideoWrapper = styled.div`
  position: relative;
  margin-top: 40px;
  padding-bottom: 56.25%;
  padding-top: 30px;
  border-radius: 17px;

  article {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    border-radius: 17px;
  }
`;
